module.exports = __webpack_public_path__ + "static/img/client30_img.6b658cb.png";